import TripOriginOutlinedIcon from '@mui/icons-material/TripOriginOutlined';
const icons = { TripOriginOutlinedIcon };

// ==============================|| MENU ITEMS - P2H INSPECTION ||============================== //

const tyreManagement = {
  id: 'tyre-management',
  type: 'group',
  children: [
    {
      id: 'tyre-management',
      title: 'Tire Management System',
      type: 'item',
      url: '/tire-vehicle-installation',
      icon: icons.TripOriginOutlinedIcon
    }
  ]
};

export default tyreManagement;
